import { useCallback } from 'react';
import { isEmpty } from 'lodash';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { COMMON_FLAGS, useCommonConfig } from '../../taboola-common-frontend-modules/account-configurations';

export const usePixelTesterData = () => {
    const { value: pixelTesterEvents = [], onChange: onPixelTesterEventsChange } = useFormFieldValue({
        field: 'pixelTesterEvents',
    });

    const { [COMMON_FLAGS.PIXEL_TESTER_EVENTS_LIMIT]: eventsLimit } = useCommonConfig([
        COMMON_FLAGS.PIXEL_TESTER_EVENTS_LIMIT,
    ]);

    const processPixelTesterData = useCallback(
        data => {
            if (!data || !data.eventTime) {
                return false;
            }

            const eventsToAdd = isEmpty(data.matchedRules)
                ? [data]
                : data.matchedRules.map(rule => ({
                      ...data,
                      matchedRules: [rule],
                  }));

            const newPixelTesterEvents = [...eventsToAdd, ...pixelTesterEvents]
                .sort((a, b) => b.eventTime - a.eventTime)
                .slice(0, eventsLimit);

            onPixelTesterEventsChange(newPixelTesterEvents);
        },
        [eventsLimit, onPixelTesterEventsChange, pixelTesterEvents]
    );

    return { processPixelTesterData };
};
